import React, { useState } from 'react';
import { CustomTooltip } from '../../Tooltip/Tooltip';
import { getPublicFolderPath, pathname, lineStatus } from '../../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import StageSelector from './StageSelector';

const useStyles = makeStyles((theme: any) => ({
  addStage: {
    width: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function AddStage({ addStage, setAutoSave, originLine }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isLineCompleted = originLine?.status === lineStatus.complete;

  const openStageSelector = (event) => {
    setAutoSave(false);
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };

  let addNewStageLogo = getPublicFolderPath(window.location.pathname);
  addNewStageLogo += 'general/add.svg';

  return (
    <>
      <div className={classes.addStage}>
        <CustomTooltip arrow title="Add new stage" placement="top">
          <IconButton
            size="small"
            onClick={isLineCompleted ? null : openStageSelector}
            disabled={
              window.location.pathname ===
              pathname.onboarding.main.lineExplained.url
            }
          >
            <img src={addNewStageLogo} alt="Plus icon" />
          </IconButton>
        </CustomTooltip>
      </div>
      <StageSelector
        open={open}
        anchorEl={anchorEl}
        setOpen={setOpen}
        onChange={(stageName: string) => {
          addStage(stageName);
          setAutoSave(true);
        }}
      />
    </>
  );
}
